export default function CACustomerServiceDirective() {
  return {
    template: require('./customer-service.directive.html'),
    scope: {
      customerService: '=',
    },
    controller: 'CACustomerServiceDirectiveController',
    controllerAs: 'customerServiceVM',
    bindToController: true,
    replace: true,
  };
}
